import {
  BUNDLE_TYPE_COMBO,
  EXPERIENCE_TYPE_GM,
  BUNDLE_TYPE_PACKAGE,
  EXPERIENCE_TYPE_KITCHEN,
  EXPERIENCE_TYPE_LAUNDRY
} from './base-configuration';

import {
  KITCHEN_INCOMPLETE_TOASTER_KEY,
  LAUNDRY_INCOMPLETE_TOASTER_KEY,
  GM_COMBO_INCOMPLETE_TOASTER_KEY
} from './codes';

import {
  DRYER_FUEL_TYPE,
  WASHER_TYPE,
  KITCHEN_FUEL_TYPE
} from './variants';

const getRatingsAndReview = (enable = true) => ({
  questionsAndAnswers: enable,
  ratingsAndReview: enable,
  starRatingProductOverview: enable,
  starRatingStickyNav: enable,
  questionStickyNav: enable,
  starRatingStickyNavTitle: enable
});

const COMBO_CONFIGURATION = {
  ...getRatingsAndReview(),
  whatWeOffer: false,
  quantity: true,
  paypalCheckout: true,
  addToCart: true,
  salientPoint: true,
  showProductUpdateAlert: false,
  dynamicImageGrid: false,
  deliveryInfo: false,
  deliveryExpress: true,
  deliveryAndTax: false,
  summaryRegularPriceType: 'items',
  calculateDeliveryFee: false,
  showBundleSavings: false,
  displayMissingProductsToaster: true,
  disableATCForMissingProducts: true,
  showQuantityLimit: true,
  hidePrice: true,
  hideBuybox: true,
  hidePlccCard: true,
  hideBundleSummary: true,
  unavailableAlertMessage: true,
  unavailableStickyNav: true,
  removeItemPromoImage: true,
  hideAddToList: true,
  showEssMessage: true
};

const PACKAGE_CONFIGURATION = {
  ...getRatingsAndReview(false),
  whatWeOffer: true,
  quantity: false,
  paypalCheckout: false,
  addToCart: false,
  salientPoint: false,
  showProductUpdateAlert: true,
  dynamicImageGrid: true,
  deliveryInfo: true,
  deliveryExpress: false,
  summaryRegularPriceType: 'appliances',
  disableATCForMissingProducts: false,
  showQuantityLimit: false,
  hidePrice: false,
  hideBuybox: false,
  hidePlccCard: false,
  hideBundleSummary: false,
  unavailableAlertMessage: false,
  enableFulfillmentTiles: false,
  unavailableStickyNav: true,
  removeItemPromoImage: false,
  hideAddToList: true,
  showEssMessage: false
};
const GM_COMBO = {
  ...COMBO_CONFIGURATION,
  productType: 'MERCHANDISE',
  missingProductToasterKey: GM_COMBO_INCOMPLETE_TOASTER_KEY,
  productListTitle: 'Items in this bundle',
  priceUnitOfMeasure: 'bundle',
  bundleSummaryTitle: 'Bundle Summary',
  enableFulfillmentTiles: true,
  unavailableAlertMessageText: 'This item is unavailable.',
  emptyContainerForUnavailableProduct: false,
  activeProductsCount: false,
  shopMoreLinkText: 'Shop More Bundles',
  unavailableBundleMessageText: 'Bundle Unavailable',
  unavailableAlertStatus: 'error',
  unavailableAlertHeadline: 'One or more items in this bundle is unavailable.',
  getAvailability: false
};

const LAUNDRY_PACKAGE = {
  ...PACKAGE_CONFIGURATION,
  ...getRatingsAndReview(),
  salientPoint: true,
  dynamicImageGrid: false,
  priceUnitOfMeasure: null,
  bundleSummaryTitle: 'Summary',
  productType: 'MERCHANDISE',
  productListTitle: 'Appliances in this set',
  deliveryAndTax: true,
  calculateDeliveryFee: true,
  showBundleSavings: true,
  templates: {
    [DRYER_FUEL_TYPE]: 'SelectableVariantTile',
    [WASHER_TYPE]: 'SelectableVariantTile'
  },
  displayMissingProductsToaster: false,
  missingProductToasterKey: LAUNDRY_INCOMPLETE_TOASTER_KEY,
  activeProductsCount: false,
  hidePrice: true,
  hideBuybox: true,
  hidePlccCard: true,
  hideBundleSummary: true,
  unavailableAlertMessage: true,
  shopMoreLinkText: 'Shop More Laundry Sets',
  unavailableBundleMessageText: 'Set Unavailable',
  oosBundleMessageText: 'Set Out of Stock',
  unavailableAlertStatus: 'warning',
  unavailableAlertHeadline: 'One or more item\'s is unavailable',
  unavailableAlertAdditionalText: 'See more laundry sets to continue shopping. ',
  unavailableAlertMessageText: 'This item is unavailable.',
  unavailableShopMoreLink: '/b/Appliances-Washers-Dryers-Washer-Dryer-Sets/N-5yc1vZ2fkpgkd',
  getAvailability: true,
  showProductUpdateGeneralAlert: true
};

const KITCHEN_PACKAGE = {
  ...PACKAGE_CONFIGURATION,
  bundleSummaryTitle: 'Package Summary',
  productType: 'MAJOR_APPLIANCE',
  priceUnitOfMeasure: 'package',
  productListTitle: 'Appliances in this package',
  deliveryAndTax: true,
  calculateDeliveryFee: true,
  showBundleSavings: true,
  templates: {
    [KITCHEN_FUEL_TYPE]: 'SelectableVariantRadio'
  },
  displayMissingProductsToaster: true,
  missingProductToasterKey: KITCHEN_INCOMPLETE_TOASTER_KEY,
  unavailableAlertMessage: true,
  unavailableAlertMessageText: 'This item is unavailable. You can add a similar item or add to cart without it.',
  emptyContainerForUnavailableProduct: true,
  unavailableStickyNav: false,
  activeProductsCount: true,
  shopMoreLinkText: 'Shop More Bundles',
  unavailableBundleMessageText: 'Bundle Unavailable',
  getAvailability: true,
  showProductUpdateGeneralAlert: false
};

const GM_PACKAGE = {
  ...PACKAGE_CONFIGURATION,
  ...getRatingsAndReview(),
  showQuantityLimit: true,
  salientPoint: true,
  dynamicImageGrid: false,
  priceUnitOfMeasure: 'bundle',
  bundleSummaryTitle: 'Bundle Summary',
  productType: 'MERCHANDISE',
  productListTitle: 'Items in this bundle',
  deliveryAndTax: false,
  calculateDeliveryFee: false,
  showBundleSavings: false,
  displayMissingProductsToaster: false,
  missingProductToasterKey: GM_COMBO_INCOMPLETE_TOASTER_KEY,
  deliveryInfo: false,
  whatWeOffer: false,
  quantity: true,
  paypalCheckout: true
};

export const BUNDLE_CONFIGURATION = {
  [BUNDLE_TYPE_COMBO]: {
    [EXPERIENCE_TYPE_GM]: GM_COMBO
  },
  [BUNDLE_TYPE_PACKAGE]: {
    [EXPERIENCE_TYPE_KITCHEN]: KITCHEN_PACKAGE,
    [EXPERIENCE_TYPE_LAUNDRY]: LAUNDRY_PACKAGE,
    [EXPERIENCE_TYPE_GM]: GM_PACKAGE
  }
};
